module.exports = __webpack_public_path__ + "img/avatar.fdc7217.svg";